<div class="modal-overlay"></div>
<div class="wrapper">
    @if (showBackButton) {
        <button class="icon icon-arrow-back" (click)="backClicked.emit()"></button>
    }
    <h2 i18n>Select table game</h2>
    <div class="content" [class.content-columns-1]="(games?.length || 0) === 1" [class.content-columns-2]="(games?.length || 0) % 2 === 0">
        @for (game of games; track game) {
            <button
                i18n
                class="button-game button-game-medium"
                [class.button-game-selected]="game === currentGame"
                (click)="gameSelected.emit(game); backClicked.emit()"
            >
                {{ game | gameLabel }}
            </button>
        }
    </div>
</div>
